import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=328d921e&scoped=true&"
import script from "./NewRequest.vue?vue&type=script&lang=js&"
export * from "./NewRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewRequest.vue?vue&type=style&index=0&id=328d921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d921e",
  null
  
)

export default component.exports